export default "__VITE_ASSET__BdkOmRYJ__"